import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

/** Card content section component */
@Component({
  selector: 'hx-card-content',
  standalone: true,
  templateUrl: './card-content.component.html',
  host: {
    class: 'hx-card__content',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HxCardContentComponent {}
